import * as React from "react";
import { SVGProps, memo } from "react";

const SvgGrayPill = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.413 16.587a4.686 4.686 0 0 1 0-6.627L9.96 3.413a4.686 4.686 0 0 1 6.627 6.626l-6.548 6.548a4.686 4.686 0 0 1-6.626 0ZM7.995 7.5l3.026-3.026a3.186 3.186 0 1 1 4.505 4.505L12.5 12.005 7.995 7.5Zm-1.52 1.697a.748.748 0 1 1 1.058 1.058L6.228 11.56c-.478.478-.672 1.216-.828 1.808-.036.139-.07.27-.106.386a.726.726 0 0 1-.518.498c-.48.119-1.068-.34-.97-.824.192-.954.508-2.071 1.257-2.82l1.412-1.411Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgGrayPill);

export default Memo;
